jQuery(document).ready(function($) {

    if(jQuery('.contact-us').length){
        function initialize() {
            var map_canvas = document.getElementById("gmap");
            var map_options = {
                center: new google.maps.LatLng(40.4040109, -80.0840678),
                zoom: 17,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            } ;
            var map = new google.maps.Map(map_canvas, map_options);
            var marker = new google.maps.Marker({ position:new google.maps.LatLng(40.4040109, -80.0840678), map: map });
        }
        google.maps.event.addDomListener(window, "load", initialize);
    }

    jQuery('#mobile-menu').click(function(e){
        e.preventDefault();

        jQuery(this).next('nav').slideToggle(300);

    });

    var windowWidth = jQuery(window).width();

    if(windowWidth < 890) {
        jQuery('nav .menu-item-has-children').each(function (index, element) {

            jQuery(element).append('<span class="fa fa-caret-down"></span>');

        });
    }

    jQuery('body').delegate('nav .menu-item-has-children span', 'click', function(){

        jQuery(this).prev('.sub-menu').slideToggle(300);

    });

    jQuery(window).resize(function(){

        windowWidth = jQuery(this).width();

        if(windowWidth > 889 ){
            jQuery('nav .menu-item-has-children span').remove();

            jQuery('nav.menu-main-menu-container').removeAttr('style');
            jQuery('nav.menu-main-menu-container .sub-menu').removeAttr('style');
        }

    });
});